<script setup>
import TabTeam from './TabTeam.vue'
import TabForm from './TabForm.vue'
import TabGeneral from './TabGeneral.vue'
import { computed } from 'vue'

const props = defineProps({
  activeTab: String,
  rawData: Object,
  generalData: Object,
})

const teamData = computed(() => {
  const team = props.rawData?.team || {}
  const teamLogo = team.logo?.small || ''
  const teamName = team.name || ''
  const manager = team.manager || {}
  const playerDataList = team.players || []

  return { playerDataList, teamLogo, teamName, manager }
})

const formData = computed(() => {
  const team = props.rawData?.team || {}
  const teamLogo = team.logo?.small || ''
  const teamName = team.name || ''
  const teamNameShort = team.abbreviation || ''
  const { pastMatches: formEntries = [] } = props.rawData
  return { formEntries, teamName, teamLogo, teamNameShort }
})
</script>

<template>
  <TabGeneral v-if="activeTab === 'general'" :data="generalData"/>
  <TabTeam v-if="activeTab === 'team'" :data="teamData"/>
  <TabForm v-if="activeTab === 'form'" :data="formData"/>
</template>
